import { render, staticRenderFns } from "./DhmeProjectsDashboardSidebar.vue?vue&type=template&id=2fd1097f&scoped=true"
import script from "./DhmeProjectsDashboardSidebar.vue?vue&type=script&lang=js"
export * from "./DhmeProjectsDashboardSidebar.vue?vue&type=script&lang=js"
import style0 from "./DhmeProjectsDashboardSidebar.vue?vue&type=style&index=0&id=2fd1097f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1097f",
  null
  
)

export default component.exports